export const SET_ATTACHMENT_LOADING = "SET_ATTACHMENT_LOADING";
